import apinode from '../../apinode'

class WmsPickingService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getBySKU(sku) {
    const response = await apinode.get(`/wmsPicking/${sku}/${this.idconta}`)

    return response.data
  }

  async create(data) {
    await apinode.post(`/wmsPicking/${this.idconta}`, {
      data,
    })
  }

  async transfer({ sku, origin, destination }) {
    await apinode.patch(`/wmsPicking/${this.idconta}`, {
      sku,
      origin,
      destination,
    })
  }

  async invert({ origin, destination }) {
    await apinode.put(`/wmsPicking/${this.idconta}`, {
      origin,
      destination,
    })
  }

  async delete(sku, codendereco) {
    await apinode.delete(`/wmsPicking/${sku}/${codendereco}/${this.idconta}`)
  }
}

export default new WmsPickingService()
